var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.892 12.652V4.312c0-1.01-.822-1.832-1.832-1.832H4.957c-1.01 0-1.833.822-1.833 1.832v8.341h-1.88v2.49a2.385 2.385 0 002.382 2.382h12.782a2.385 2.385 0 002.383-2.382v-2.49h-1.899zM4.374 4.312c0-.321.262-.582.583-.582H15.06c.321 0 .582.26.582.582v8.341h-3.835v.625a.583.583 0 01-.583.583H8.81a.583.583 0 01-.582-.583v-.625H4.374V4.311zm13.167 10.83c0 .625-.508 1.133-1.133 1.133H3.626a1.134 1.134 0 01-1.133-1.132v-1.24h4.594A1.835 1.835 0 008.81 15.11h2.414c.791 0 1.467-.504 1.723-1.207h4.594v1.239zm-8.443-4.493h.003a.625.625 0 00.441-.182l3.153-3.145a.625.625 0 00-.882-.885l-2.708 2.7-.88-.892a.625.625 0 10-.89.877l1.32 1.341a.625.625 0 00.443.186z",
    fill: "#A7B4D0",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/assets/delivery.85899770.svg";
export { ForwardRef as ReactComponent };